import UserRoles from '@/common/enums/user-roles.enum';
import { Membership, User } from '@/common/models';
import { IBackgroundOperation } from '@/common/models/background-operations/BackgroundOperationsBatch';
import UserProfile from '@/common/models/user/UserProfile';
import { ExchAppStore } from '@/exch-app/store/exch-app-store-types';
import { OrgAppStore } from '@/org-app/store/org-app-store-types';

interface InitialState {
  authenticated: boolean;
  backgroundOperations: IBackgroundOperation[];
  chosenMembershipType: 'org' | 'exch';
  debugMode: boolean;
  isAppOffline: boolean;
  isNewVersionAvailable: boolean;
  isPublicRoute: boolean;
  membership: Membership;
  user: User;
  userProfile: UserProfile;
  userRole: UserRoles;
  orgApp?: OrgAppStore['modules'] & OrgAppStore['state'];
  exchApp?: ExchAppStore['modules'] & ExchAppStore['state'];
}

const initialState: InitialState = {
  authenticated: false,
  backgroundOperations: [],
  chosenMembershipType: null,
  debugMode: false,
  isAppOffline: false,
  isNewVersionAvailable: false,
  isPublicRoute: true,
  membership: null,
  user: {} as User, // The user object.
  userProfile: {} as UserProfile, // A collection of user settings.
  userRole: {} as UserRoles, // The user's role.
};

export default initialState;
